/* External */
import { memo } from 'react';
import PropTypes from 'prop-types';

/* Utils */
import { ClassNames } from '../../../../utils/misc';

/* Styles */
import './ContentInformation.scss';

export const ContentInformationClassNames = ClassNames.component('content-information');

function ContentInformation({ className, children }) {
  return (
    <div className={ContentInformationClassNames.block(className)}>
      {children}
    </div>
  );
}

ContentInformation.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

ContentInformation.defaultProps = {
  className: '',
  children: undefined,
};

export default memo(ContentInformation);
